import utils from "@/utils/utils";
import moment from "moment";

const filters = {
  /**
   * 删除类型
   * @param parameter
   * @returns {string}
   */
  getPlatformUrl(path) {
    let url = process.env.PLATFORM_URL;
    if (path) {
      url += "/" + path;
    }
    return url;
  },
  getProductDetailUrl(productId) {
    return process.env.PLATFORM_URL + "/productDetail/" + productId;
  },
  getAlreadyShelves() {
    return process.env.PLATFORM_URL + "/alreadyShelves";
  },
  getMemberUrl() {
    return process.env.PLATFORM_URL + "/member";
  },
  formatTimeStamp(timeStamp, format) {
    return utils.formatTimeStamp(timeStamp, format);
  },
  formatDate(date, format) {
    if (!date) {
      return "";
    }
    if (!format) {
      format = "YYYY-MM-DD";
    }
    return moment(date).format(format);
  },
  formatDatePoint(date, format) {
    if (!date) {
      return "";
    }
    if (!format) {
      format = "YYYY.MM.DD";
    }
    return moment(date).format(format);
  },
  formatNumber(num, digits, isThousand) {
    return utils.formatNumber(num, digits, isThousand);
  },
  formatDateTime(timeStamp) {
    return moment.unix(moment(timeStamp).unix()).format("YYYY-MM-DD HH:mm:ss");
  }
};

export default Vue => {
  Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key]);
  });
};



// WEBPACK FOOTER //
// ./src/filters/index.js